// extracted by mini-css-extract-plugin
export var gridWrapper = "index-module--gridWrapper--7ae63";
export var header = "index-module--header--8da82";
export var root = "index-module--root--ef8cc";